import React from "react";
import TagActionsMenu from "./tag-actions-menu.component";
import ColorPickerDropdown from "./color-picker-dropdown.component";
import styles from "./index.module.scss";
import cn from "../../../../Utils/class-names.utils";

interface TagData {
  id: number;
  name: string;
  associatedMSPs: number;
  color: string;
  isEditing?: boolean;
  isDisabled?: boolean;
}

interface TagRowProps {
  tag: TagData;
  editingTagId: number | null;
  editingValue: string;
  inputRef: React.RefObject<HTMLInputElement>;
  onTagNameClick: (tag: TagData) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onInputBlur: () => void;
  onColorSelect: (tagId: number, color: string) => void;
  onToggleDisable?: (tagId: number) => void;
  onDelete?: (tagId: number) => void;
}

const TagRow: React.FC<TagRowProps> = ({
  tag,
  editingTagId,
  editingValue,
  inputRef,
  onTagNameClick,
  onInputChange,
  onInputKeyDown,
  onInputBlur,
  onColorSelect,
  onToggleDisable,
  onDelete,
}) => {
  const handleColorSelect = (color: string) => {
    onColorSelect(tag.id, color);
  };

  return (
    <div className={styles.row}>
      <div className={cn(styles.rowCell)}>
        <div className={cn(styles.tagNameColumn, "text-ellipsis")}>
          {editingTagId === tag.id ? (
            <div className={styles.editingInput}>
              <div className={styles.editingInputContent}>
                <div className={styles.editingInputInner}>
                  <input
                    ref={inputRef}
                    type="text"
                    className={styles.editingInputText}
                    value={editingValue}
                    onChange={onInputChange}
                    onKeyDown={onInputKeyDown}
                    onBlur={onInputBlur}
                  />

                  <div className={styles.dividerContainer}>
                    {/* <img
                      className="relative flex-1 w-px grow ml-[-0.50px] object-cover"
                      alt="Divider"
                      src={divider}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={cn(styles.tagNameDisplay, "text-ellipsis")}>
              <div className={cn(styles.tagNameWrapper, "text-ellipsis")}>
                <div
                  className={cn(styles.tagName, "text-ellipsis", {
                    [styles.disabled]: tag.isDisabled
                  })}
                  onClick={() => onTagNameClick(tag)}
                  style={{
                    cursor: tag.isDisabled ? "default" : "pointer",
                  }}
                >
                  <span className="text-ellipsis">{tag.name}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.rowCell}>
        <div className={styles.associatedMSPsColumn}>
          <div className={styles.associatedMSPsCell}>
            <div className={styles.associatedMSPsContent}>
              <div
                className={`${styles.associatedMSPsText} ${
                  tag.isDisabled ? styles.disabled : ""
                }`}
              >
                {tag.associatedMSPs}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rowCell}>
        <div className={styles.colorColumn}>
          <ColorPickerDropdown
            color={tag.color}
            isDisabled={tag.isDisabled}
            onColorSelect={handleColorSelect}
            popperConfig={{ strategy: "fixed" }}
            renderOnMount
          />
        </div>
      </div>

      <div className={styles.rowCell}>
        <div className={styles.actionsColumn}>
          <TagActionsMenu
            isDisabled={tag.isDisabled}
            onToggleDisable={() => onToggleDisable?.(tag.id)}
            onDelete={() => onDelete?.(tag.id)}
          />
        </div>
      </div>
    </div>
  );
};

export default TagRow;
export type { TagData };

